/**
 * CSS personnalisé PAR PAGE — stocké dans `layout.root.props.customCss`.
 * Structurel (identique toutes langues), Json opaque côté API.
 *
 * KEEP IN SYNC avec inventozen-frontpublic/src/cms-puck/page-custom-css.ts
 */

export function normalizePageCustomCss(value: unknown): string {
  if (typeof value !== "string") return "";
  return value.trim();
}

/**
 * Nettoie le CSS saisi avant injection dans une balise `<style>`.
 * Pas un parseur CSS complet — retire les vecteurs évidents (HTML, JS, @import).
 */
export function sanitizePageCustomCss(raw: string): string {
  let css = normalizePageCustomCss(raw);
  if (!css) return "";

  css = css.replace(/<\/?style[^>]*>/gi, "");
  css = css.replace(/<script[\s\S]*?<\/script>/gi, "");
  css = css.replace(/<\/?[^>]+>/g, "");

  css = css.replace(/expression\s*\(/gi, "/* blocked */");
  css = css.replace(/javascript\s*:/gi, "/* blocked */");
  css = css.replace(/@import[\s\S]*?;/gi, "/* @import blocked */");
  css = css.replace(/-moz-binding\s*:/gi, "/* blocked */");
  css = css.replace(/behavior\s*:/gi, "/* blocked */");

  return css.trim();
}
